import { BsModalService } from 'ngx-bootstrap/modal';
import { ServiceLocator } from '../../service-locator.service';

export abstract class AbstractTopBannerType {
	public abstract largeBannerClassName: string;
	public abstract smallBannerClassName: string;
	public abstract bannerHeaderHtml: string;

	protected modalService: BsModalService;

	constructor() {
		this.modalService = ServiceLocator.injector.get(BsModalService);
	}

	public abstract onActionClicked(): Promise<void>;
}
